<script>
import numeral from 'numeral'

import { NumberInput } from '@/components/form/number-input'

export default {
  functional: true,

  props: {
    amount: {
      type: Number,
      default: 0
    },

    discount: {
      type: Number,
      default: 0
    },

    fee: {
      type: Number,
      default: 0
    }
  },

  render(h, { data, props, listeners, $style, elementUiStyles }) {
    const total = props.amount - props.discount

    const totalWithFee = total + props.fee

    const handleDiscountNumberInputInput = value => {
      listeners['update:discount'] && listeners['update:discount'](value)
    }

    const Amount = () => (
      <el-row
        type="flex"
        gutter={16}
        style={{
          flexWrap: 'wrap',
          alignItems: 'baseline',
          fontSize: '1rem',
          fontWeight: 'bold'
        }}
      >
        <el-col md={14}>
          <label class={$style.label}>ยอดเงิน</label>
        </el-col>
        <el-col md={10} style={{ textAlign: 'right' }}>
          {numeral(props.amount).format('0,0.00')}
        </el-col>
      </el-row>
    )

    const Discount = () => (
      <el-row
        type="flex"
        gutter={16}
        style={{ flexWrap: 'wrap', marginTop: '1rem' }}
      >
        <el-col
          md={8}
          style={{
            display: 'flex',
            alignItems: 'center',
            maxHeight: '2.5rem'
          }}
        >
          <label class={$style.label}>ส่วนลด</label>
        </el-col>
        <el-col md={16}>
          <NumberInput
            value={props.discount}
            min={0}
            max={100}
            class={[$style.paymentInput, elementUiStyles.numberInput]}
            onInput={handleDiscountNumberInputInput}
          />
          <div
            style={{
              color: '#d0021b',
              textAlign: 'right',
              marginTop: '0.25rem'
            }}
          >
            * ส่วนลด ลดได้ไม่เกิน 100 บาท
          </div>
        </el-col>
      </el-row>
    )

    const Total = () => (
      <el-row
        type="flex"
        gutter={16}
        style={{
          flexWrap: 'wrap',
          alignItems: 'baseline',
          marginTop: '1rem',
          fontSize: '1.25rem',
          fontWeight: 'bold'
        }}
      >
        <el-col md={14}>
          <label>รวม (บาท)</label>
        </el-col>
        <el-col md={10} style={{ textAlign: 'right' }}>
          {numeral(total).format('0,0.00')}
        </el-col>
      </el-row>
    )

    const Fee = () => (
      <el-row
        type="flex"
        gutter={16}
        style={{
          flexWrap: 'wrap',
          alignItems: 'baseline',
          marginTop: '0.5rem',
          fontSize: '1rem',
          fontWeight: 'bold'
        }}
      >
        <el-col md={14}>
          <label>ค่าธรรมเนียม</label>
        </el-col>
        <el-col md={10} style={{ textAlign: 'right' }}>
          {numeral(props.fee).format('0,0.00')}
        </el-col>
      </el-row>
    )

    const TotalWithFee = () => (
      <el-row
        type="flex"
        gutter={16}
        style={{
          flexWrap: 'wrap',
          alignItems: 'baseline',
          marginTop: '0.5rem',
          fontSize: '1.25rem',
          fontWeight: 'bold'
        }}
      >
        <el-col md={14} style={{ fontSize: '1rem' }}>
          <label>ยอดชำระรวมค่าธรรมเนียม (บาท)</label>
        </el-col>
        <el-col md={10} style={{ textAlign: 'right' }}>
          {numeral(totalWithFee).format('0,0.00')}
        </el-col>
      </el-row>
    )

    return (
      <div {...data}>
        <Amount />
        <Discount />
        <Total />
        <Fee />
        <TotalWithFee />
      </div>
    )
  }
}
</script>

<style lang="scss" module>
.label {
  font-size: 1rem;
  font-weight: bold;

  &.isLarge {
    font-size: 1.25rem;
  }
}

.paymentInput {
  :global(.el-input__inner) {
    font-weight: bold;
    font-size: 1rem;
    text-align: right;
  }

  &.isLarge {
    :global(.el-input__inner) {
      font-size: 1.25rem;
    }
  }
}
</style>

<style
  src="@/assets/scss/modules/element-ui.module.scss"
  lang="scss"
  module="elementUiStyles"
></style>
